module.exports = __webpack_public_path__ + "img/two.4b4a6e8e.png";